import { useEffect, useState } from 'react';
import { Cookies } from 'react-cookie';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { API_SERVER } from '../../EnvConfig/env_config';
import { getCommonData } from '../Common/CommanServices';
import { BindReportGrid, exportToExcel, formatDate, OpenBase64Pdf, ReverseFormatDate, setFocus, setTitle } from '../Common/Common';
import { AlertBox, AutoCompleteBox } from '../Common/Input';
import { post } from '../Common/service';
import { useNavigate } from "react-router-dom";
import Loader from '../Layout/Loader';

const PaymentReport = ({ open, setOpen }) => {
    const [isUpdate, setIsUpdate] = useState(false)
    const [MenuText, setMenuText] = useState("Payment Receipt Report");
    const cookies = new Cookies();
    const Token = cookies.get('token')
    const LoginUserCode = cookies.get('loginUserCode');
    const [CustomerData, setCustomerData] = useState([]);
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [isLoading, setIsLoading] = useState(false);
    const [tableData, setTableData] = useState({})
    const navigate = useNavigate();

    const [FilterData, setFilterData] = useState({
        PageIndex: "1",
        InvoiceNo: "",
        Customer: "",
        DateFrom: "",
        DateTo: "",
    });

    useEffect(() => {
        setTitle('PaymentReport', setOpen);
        setFocus('txtInvoiceNo');
        setTimeout(() => {
            setMenuText(document.title);
        }, 500)
    }, [])

    const handleClearData = () => {
        setFilterData(
            {
                PageIndex: "1",
                InvoiceNo: "",
                Customer: "",
                DateFrom: "",
                DateTo: "",
            }
        );
        setFocus('txtInvoiceNo');
        setIsUpdate(!isUpdate)
    }

    const searchHandle = () => {
        setFilterData({
            ...FilterData,
            PageIndex: "1",
        })
        getPaymentReportData()
    }

    const handleDownloadExcel = async () => {
        getPaymentReportData('E');
    }

    const HandleChange = (prop, value) => {
        setFilterData(FilterData => ({ ...FilterData, [prop]: value }));
    }
 
    const getPaymentReportData = (Type = 'S',  PI = FilterData?.PageIndex || "1") => {
        const loginCodeString = String(LoginUserCode);
        const data = {
            ...FilterData, Type: Type, Token, LoginUserCode: loginCodeString, PageIndex: `${PI}`
        }
        setIsLoading(true)
        post(`${API_SERVER}/api/Report/ShowExPaymentReceiptReport`, { ...data }, (res) => {
            if (res.Status === 'SUCCESS') {
                if (Type === 'S') {
                    setTableData({
                        ...res
                    });
                }
                else {
                    if (Array.isArray(res.Data)) {
                        exportToExcel(res.Data, 'PaymentReceipt');
                    }
                }
            }
            else if (res.Status === "EXPIRED") {
                navigate('/Login')
            }
            else if (res.Message !== "") {
                AlertBox(res.Status, res.Message, res.Focus);
                setTableData({});
            }
            setIsLoading(false)
        });
    }
    const handlePrintData = (ID) => {
        const loginCodeString = String(LoginUserCode);
        const data = {
            PaymentReceiptNo: ID.PaymentReceiptNo,
            Source: "Report",
            Token,
            LoginUserCode: loginCodeString
        };
        setIsLoading(true)
        post(`${API_SERVER}/api/Print/PaymentReceiptPrint`, { ...data }, (res) => {
            if (res.message === 'EXPIRED') {
                navigate('/Login')
            }
            else if (res.status === 'SUCCESS') {
                console.log(res, "resresres")
                OpenBase64Pdf(res.documentPdfBase64, 'PaymentReceiptPrint_' + ID, '_blank');
            }
            if (res.status === 'ERROR' || res.message !== '') {
                AlertBox(res.status, res.message, res.focus);
            }
            if (res.focus !== "") {
                setFocus(res.focus);
            }
            setIsLoading(false)
        });
    }
    const handleChange1 = (event, value) => {
        getPaymentReportData('S',value);
    };

    //useEffect(() => {
    //    getPaymentReportData();
    //}, [FilterData.PageIndex, isUpdate])

    const getCustomer = () => {
        setCustomerData([])
        let temp = {
            Type: "GetCustomer",
            Prefix: "",
            ContextKey: "",
            ContextKey2: ""
        }
        const loginCodeString = String(LoginUserCode);
        const data = {
            Token: Token, LoginUserCode: loginCodeString
        }

        getCommonData({ ...data, ...temp }, (res) => {
            if (res && res.status === "SUCCESS") {
                let CustomerDatalist = res.autoCompleteData || [];
                setCustomerData(CustomerDatalist);
            } else {
                setCustomerData([]);
            }
        });
    }

    let CustomerArr = []
    for (let i = 0; i < CustomerData.length; i++) {
        let mydata = CustomerData[i]?.values
        CustomerArr.push(mydata)
    };


    useEffect(() => {
        if (FilterData.DateFrom) {
            const fromDateObj = new Date(FilterData.DateFrom);
            const toDateObj = new Date(FilterData.DateTo);

            if (
                !FilterData.DateTo ||
                toDateObj <= fromDateObj
            ) {
                const nextDay = new Date(fromDateObj);
                nextDay.setDate(fromDateObj.getDate() + 1);

                const formattedNextDay = formatDate(nextDay);

                setFilterData(prev => ({
                    ...prev,
                    DateTo: formattedNextDay
                }));
            }
        }
    }, [FilterData.DateFrom]);
    return (
        <main id="main" className="main" style={open ? {} : { marginLeft: "0" }}>
            <section className="section dashboard">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="content-box">
                            <div className="heading-box">
                                <div className="heading">
                                    <h6 className="m-0 font-weight-bold text-primary">{MenuText}</h6>
                                </div>
                            </div>
                            <div className="form-box service-content-area">
                                <div className="row align-items-end">
                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">Invoice No.</label>
                                            <input
                                                maxLength="50"
                                                id='txtInvoiceNo'
                                                type="text"
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') { setFocus("txtCustomer") };
                                                }}
                                                className="form-control"
                                                placeholder='Enter Invoice No'
                                                value={FilterData.InvoiceNo}
                                                onChange={(e) => {
                                                    setFilterData({ ...FilterData, InvoiceNo: e.target.value.toUpperCase() })
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <AutoCompleteBox
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') { setFocus("txtInvoiceDateFrom") };
                                                }}
                                                label='Customer '
                                                placeholder="Customer "
                                                maxLength='50'
                                                options={CustomerArr}
                                                id='txtCustomer'
                                                required={false}
                                                ignore_common={true}
                                                onFocus={() => getCustomer()}
                                                inputValue={FilterData.Customer ? FilterData.Customer : ''}
                                                onInputChange={(event, newInputValue) => {
                                                    HandleChange('Customer', newInputValue)
                                                }}

                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">Invoice Date</label>
                                            <div className="row">
                                                <div className="col-3">
                                                    <DatePicker selected={ReverseFormatDate(FilterData.DateFrom) || null}
                                                        id='txtInvoiceDateFrom'
                                                        className="form-control"
                                                        placeholderText='From Date'
                                                        dateFormat={'dd-MMM-yyyy'}
                                                        autoComplete='off'
                                                        onChange={(date) => {
                                                            setFilterData({ ...FilterData, DateFrom: date ? formatDate(date) : '' })
                                                        }}
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Enter') {
                                                                setFocus('txtInvoiceDateTo')
                                                            };
                                                        }}
                                                        maxDate={new Date()}
                                                    /></div>
                                                <div className="col-3">
                                                    <DatePicker selected={ReverseFormatDate(FilterData.DateTo) || null}
                                                        id='txtInvoiceDateTo'
                                                        className="form-control"
                                                        placeholderText='To Date'
                                                        dateFormat={'dd-MMM-yyyy'}
                                                        autoComplete='off'
                                                        onChange={(date) => {
                                                            setFilterData({ ...FilterData, DateTo: date ? formatDate(date) : '' })
                                                        }}
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Enter') {
                                                                setFocus('txtReportType')
                                                            };
                                                        }}
                                                        minDate={new Date(FilterData.DateFrom) || null}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-12 mt-1">
                                        <div className="lms-new-button text-center">
                                            <button className="button save-btn" id='btnSearch' onClick={searchHandle}>
                                                <i className="bi bi-search" /> Search
                                            </button>
                                            <button className="button export-btn" onClick={handleDownloadExcel}>
                                                <i className="bi bi-download" /> Export
                                            </button>
                                            <button className="button reset-btn" onClick={handleClearData} >
                                                <i className="bi bi-arrow-clockwise" /> Reset
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <BindReportGrid tableData={tableData} setFilterData={setFilterData} filterData={FilterData} handleChange1={handleChange1} currentPageNo={currentPageNo}
               handlePrintButton={handlePrintData}/>
            {isLoading ? <Loader text='Please wait' size='100px' img_path='./assets/img/giphy.gif' /> : <></>}
        </main>
    )
}
export default PaymentReport